import { render, staticRenderFns } from "./perevod.vue?vue&type=template&id=afe34258"
import script from "./perevod.vue?vue&type=script&lang=js"
export * from "./perevod.vue?vue&type=script&lang=js"
import style0 from "./perevod.vue?vue&type=style&index=0&id=afe34258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports